import { queries } from 'RestAPIs/rapini';

/** All of the plan unit's own schedules: a plan unit holds a few per year, so none are left out. */
export const useGetOpeningSchedules = (planUnitId: number) =>
  queries.useGetOpeningSchedules(planUnitId);
